import config from '@/config'
import util from '@/util'
import ActiveTabNames from '@/constant/ActiveTabNames'

const presentationDefaultState = {
  presentation: {
    slides: [],
    isShowingSlideSearch: false,
    id: null,
  },
  importStatus: 1,
  importError: '',
  isPreview: false,
  presentations: [],
  currentUser: {},
  workingMode: null,
  presenterLocale: util.getPresenterLocaleDefault(),
  presenterLanguageSelected: null,
  isSyncing: 2,
  activeModelDetailSlide: false,
  isNewPresentation: true,
  currentSlideMode: '',
  currentSlideCanvas: '',
  isQRCodeVisible: false,
  showExport: false,
  sharePresentation: false,
  audiences: {},
  continueQuiz: false,
  originScreen: false,
  userOnline: 0,
  onlineStatus: 1,
  plan: {},
  countPlayer: 0,
  showQnaSession: false,
  questions: [],
  tabQnaQuestion: 1,
  lastQuestion: {},
  questionCount: 0,
  countTopQuestion: 0,
  countPinnedQuestion: 0,
  countAnswerQuestion: 0,
  showLiveAudienceDemo: false,
  isTouchScreen: false,
  openImportModal: false,
  quizConfirmation: false,
  quizConfirmationType: null,
  historyKeyboard: null,
  tempAudienceCount: 0,
  isAdmin: false,
  transitionContent: '',
  isPresenterWhiteLabel: true,
  // support export pdf capture slide on presentation sharing. url has params capture=true
  isScreenCapture: false,
  hasNews: false,
  isUploadImageInProcess: false,
  requestedApplyConfigsToAll: false,
  isShowAnimationEditor: false,
  isShowLinkEditorModal: false,
  isShowLinkEditorModalV3: false,

  // ids
  activeSlideId: null,

  // loaders
  loaders: {
    morePresentationsLoading: false,
  },

  // numbers
  numbers: {
    numberOfPresentationPages: 1,
    numberOfLoadedPresentationPages: 1,
  },

  // indicators
  isTokenValid: true,

  indicators: {
    isServerConnectable: true,
    isWelcomePopupShowing: false,
    isRouterViewContentShowing: false,
    isHomeSideBarShowing: false,
    showingSlideGrid: false,
  },

  // url
  clickedUrl: '',

  // errors
  errors: {
    errorOnInternalServer: null,
  },

  // selections
  selections: {
    selectedTab: ActiveTabNames.UPLOAD,
    selectedFolderId: null,
    selectedSlideIds: [],
    selectedSortCriteria: {
      sortColumn: 'updatedAt',
      sortOrder: 'desc',
    },
  },
  // AI
  slideGenerator: {
    gaTouchPointWhenOpenAIModal: null,
  },
  aiGenerateDescriptionDuration: 0,
  presentIsBeginning: false,
  presentIsExtraButton: false,
  slideTypePreview: {},
  presentationEditors: [],
  isDisableEditPresentation: false,
  canEditPresentation: false,
  isComeFromSignupPage: false, // check audience come from signup page
  isPlayDemoMode: false,
  isCreatingNewPresentation: false, // for loading screen when creating new presentation
  search: {
    searchBy: 'template', // global merge search
    totalTemplates: 0,
    totalPresentations: 0,
  },
  undoHistory: [],
  redoHistory: [],
  dataEventBusHistory: {},
  isBlockHistory: false,
  pendingCanvasBlockPayload: null,
  mapLockAddHistory: {},
  isLockAddHistory: 0,
  arrKeyLockAddHistory: [],
  allCanvasBlocks: {},
  isReferPublicTemplate: false,
  voiceCall: {},
  isRightClickInfoBoxVisible: true,
  mapAudienceIdWinnerRemoved: {},
  clipboardBlocks: null,
  clipboardSlideId: null,
  selectingBlocks: [],
  isAudioPlayingBeforeSlideSpinner: false,
  isMSTeamsApp: false,
  userInactiveReload: false,
  userOnlineByPresentationId: [],
  isFocusInputCommentPresentation: false,
  isShowNotificationPanel: false, // open panel notication in my presentation list
  notificationUnread: 0, // count notification unread
  notifications: [], // list notifications
  createdPresentationFromQuizHintsBanner: false,
  isOpeningPrivateFeedback: false,
  exportingType: null,
  loadingExportImage: false,
  loadingExportPdfV2: false,
  loadingExportExcelV2: false,
  loadingExportExcelV5: false,
  renderPresentationDetail: false, // handle show loading screen presentation detail page
  isPowerPointAddIn: false, // check app running in powerpoint addin
  powerPointPresentationId: null,
  powerPointSlideId: null,
  isEnableAddinPowerpoint: config.isEnableAddinPowerpoint || false, // check run in domain powerpoint add in
  isOpenEditSlidePowerPoint: true,
  hasAutoSuggestedTitle: false,
  activePresentationPowerpointId: null,
  planBenefit: {},
  planBenefitLimitation: {},
  presentationSlideLimits: null,
  presentationSlideLimitsPresentationId: null,
  countReconnectSocket: 0,

  // everyone answered count
  totalJoinedPresentation: {},
  totalAnsweredSlide: {},

}

export default presentationDefaultState
